import * as React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What does Evermark produce for marine and aerospace OEMs?",
  answer: <>
        Evermark Industrial Solutions produces MIL-SPEC phenolic and metal
        nameplates and data plates, plus direct part marking with serialization
        and 2D data matrix, for marine and aerospace equipment and components.
      </>
}, {
  question: "Does Evermark mark to MIL-DTL-15024 and MIL-STD-130?",
  answer: <>
        Evermark Industrial Solutions produces marking designed to align with
        standards such as MIL-DTL-15024, MIL-P-15035, MIL-STD-130, and AS9132
        when properly specified; whether marking meets a contract depends on the
        program's requirements and quality system, which Evermark recommends
        confirming with the customer's quality engineer.
      </>
}, {
  question: "Is Evermark AS9100 or ISO 9001 certified?",
  answer: <>
        {"{{verify: quality-system certification status}}"} — Evermark
        Industrial Solutions states its quality-system certifications here only
        as held; this answer must reflect actual certification status and never
        claim a certification that is not in place.
      </>
}, {
  question: "Can Evermark mark IUID / 2D data matrix for traceability?",
  answer: <>
        Yes — Evermark Industrial Solutions marks unique item identifiers (UII)
        and 2D data matrix codes designed to align with MIL-STD-130 and ISO/IEC
        16022 when specified, from a customer-supplied serialization sequence.
      </>
}, {
  question: "Can the marks be verified or graded?",
  answer: <>
        When a program requires it, Evermark Industrial Solutions verifies and
        grades direct part marks against the applicable standard; the
        verification method and reported grade are confirmed at program setup —
        see {"{{verify: verification capability}}"}.
      </>
}, {
  question: "Do you handle recurring programs and first articles?",
  answer: <>
        Yes — Evermark Industrial Solutions approves a first article before each
        program run and runs recurring marking with locked-in method, layout,
        and serialization so every lot matches the approved article.{" "}
        <Link to="/ContactPage" className="text-primary hover:underline font-medium">
          Request a quote
        </Link>{" "}
        to start a program.
      </>
}];
export default function Faq() {
  return <section id="faq" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div className="mb-10 text-center md:mb-14">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Marine & Aerospace Marking — Common Questions
          </h2>
        </div>

        <div className="mx-auto w-full rounded-lg border border-border bg-card p-4 shadow-sm md:p-6">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border-border">
                <AccordionTrigger className="font-default text-base font-semibold text-card-foreground hover:text-primary text-left">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-base leading-relaxed text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}